var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    (
      _vm.sidebar === true
        ? "class='col-12 m-auto'"
        : "class='col-12 col-md-5 m-auto'"
    )
      ? _c("div", [
          _c("div", { staticClass: "card" }, [
            _c(
              "a",
              {
                staticClass:
                  "btn btn-outline-white text-white btn-default waves-effect waves-light position-absolute m-05",
                attrs: { href: "#" },
              },
              [
                _c("i", { staticClass: "feather icon-arrow-left" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.__("meeting.form.buttons.back")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.has_edit_permission === true
              ? _c(
                  "div",
                  {
                    staticClass: "position-absolute float-right",
                    staticStyle: { right: "0.5rem", top: "0.5rem" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-dark waves-effect waves-light",
                        attrs: {
                          href:
                            "/member/zoom/" + _vm.data.module.slug + "/edit",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.__("meeting.form.buttons.edit")) + " "
                        ),
                        _c("i", { staticClass: "fa fa-wrench" }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "shadow" }, [
              _c("img", {
                staticClass: "card-img-top img-fluid",
                staticStyle: { "object-fit": "cover" },
                attrs: {
                  src:
                    _vm.data.module.media.length > 0
                      ? _vm.data.module.media[0].url
                      : "/images/cover.jpg",
                },
              }),
            ]),
            _vm._v(" "),
            _vm.data.module.description !== null
              ? _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "card-body pt-05 pb-05" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("div", [
                        _c("h1", {
                          staticClass: "font-large-1",
                          domProps: {
                            textContent: _vm._s(_vm.data.module.title),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "h2",
                          { staticClass: "primary font-medium-3 pb-2" },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(_vm.showDateTime),
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-auto pt-1" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              " badge badge-pill bg-gradient-primary",
                            staticStyle: { padding: "0.2rem 0.5rem" },
                          },
                          [
                            _c("i", { staticClass: "feather icon-video" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.__("meeting.title_singular")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-md-8" }, [
                        _c("h5", { staticClass: "border-bottom pb-05 mb-1" }, [
                          _c("i", { staticClass: "feather icon-book-open" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.__("meeting.headers.admin.event_details")
                              ) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-start" },
                          [
                            _c("p", [
                              _c(
                                "span",
                                { staticClass: "user-name text-bold-600" },
                                [
                                  _c("i", { staticClass: "fa fa-clock" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.__("meeting.fields.text.timezone")
                                      ) +
                                      ": "
                                  ),
                                ]
                              ),
                              _c("br"),
                              _vm._v(
                                _vm._s(_vm.data.module.timezone) +
                                  "\n                                "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "span",
                            { staticClass: "user-name text-bold-600" },
                            [
                              _c("i", { staticClass: "fas fa-file-alt" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.__("meeting.field.text.description")
                                  ) +
                                  ": "
                              ),
                            ]
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "breakAll image-resize",
                            domProps: {
                              innerHTML: _vm._s(_vm.data.module.description),
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-4" }, [
                        _c("h5", { staticClass: "border-bottom pb-05 mb-1" }, [
                          _c("i", { staticClass: "feather icon-user-plus" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.__("meeting.headers.admin.event_organiser")
                              ) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "span",
                            { staticClass: "user-name text-bold-600" },
                            [
                              _c("i", { staticClass: "fa fa-building" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.__(
                                      "meeting.fields.text.organisation_name"
                                    )
                                  ) +
                                  ": "
                              ),
                            ]
                          ),
                          _c("br"),
                          _vm._v(
                            _vm._s(_vm.data.module.organisation_name) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "span",
                            { staticClass: "user-name text-bold-600" },
                            [
                              _c("i", { staticClass: "fa fa-user" }),
                              _vm._v(
                                " " + _vm._s(_vm.__("globals.name")) + ": "
                              ),
                            ]
                          ),
                          _c("br"),
                          _vm._v(_vm._s(_vm.data.module.contact_name)),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "span",
                            { staticClass: "user-name text-bold-600" },
                            [
                              _c("i", { staticClass: "fa fa-phone" }),
                              _vm._v(
                                " " + _vm._s(_vm.__("globals.phone")) + ": "
                              ),
                            ]
                          ),
                          _c("br"),
                          _vm._v(
                            _vm._s(_vm.data.module.contact_phone) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "span",
                            { staticClass: "user-name text-bold-600" },
                            [
                              _c("i", { staticClass: "fa fa-envelope" }),
                              _vm._v(
                                " " + _vm._s(_vm.__("globals.email")) + ": "
                              ),
                            ]
                          ),
                          _c("br"),
                          _vm._v(
                            _vm._s(_vm.data.module.contact_email) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.data.module.user_registered === false
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex pr-05 align-items-center border-top pt-1",
                          },
                          [
                            _vm.data.module.event_price !== null &&
                            _vm.data.module.event_price !== 0
                              ? _c("div", [
                                  this.price_setting === "plan-price"
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "text-bold-700" },
                                          [
                                            _c("span", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.__(
                                                      "globals.form.paragraph.your_price"
                                                    )
                                                  ) +
                                                    "\n                                            " +
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        _vm.data.module
                                                          .event_price,
                                                        _vm.site_tax
                                                      )
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm.price_setting === "one-price" &&
                                      _vm.data.module.event_price !== null
                                    ? _c("div", [
                                        _c("span", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.__(
                                                  "globals.form.paragraph.your_price"
                                                )
                                              ) +
                                                "\n                                        " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    _vm.data.module.event_price,
                                                    _vm.site_tax
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "ml-auto" }, [
                              _vm.data.module.event_price !== null &&
                              _vm.data.module.event_price !== 0
                                ? _c("span", [
                                    _c("div", {}, [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "download-button btn btn-primary waves-effect waves-light form-control",
                                          attrs: {
                                            href:
                                              "/member/zoom/" +
                                              _vm.data.module.zoom_id +
                                              "/add_to_cart",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-dollar",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.__(
                                                  "meeting.form.buttons.buy_now"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.data.module.event_price === 0 ||
                              _vm.data.module.event_price === null
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "download-button btn btn-primary waves-effect waves-light form-control",
                                        attrs: {
                                          href:
                                            "/member/zoom/" +
                                            _vm.data.module.zoom_id +
                                            "/register",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-calendar",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.__(
                                                "meeting.form.buttons.register_now"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex border-top justify-content-between" },
              [
                _c(
                  "div",
                  { staticClass: "font-small-3 text-bold-700" },
                  [
                    _c("likes", {
                      attrs: {
                        id: this.data.module.zoom_id,
                        "likes-count": this.data.likesCount,
                        "is-liked": this.data.isLiked,
                        "liked-by-users": this.data.userLikes,
                        type: this.data.type,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "font-small-3 text-bold-700" }, [
                  _c(
                    "a",
                    {
                      staticClass: "p-05 d-block",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.commentsShow = !_vm.commentsShow
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-comment-o" }),
                      _vm._v(" "),
                      _vm.commentsCount === 1
                        ? _c("span", [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(_vm.commentsCount),
                              },
                            }),
                            _vm._v(" " + _vm._s(_vm.__("globals.comment"))),
                          ])
                        : _c("span", [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.commentsCount === 0
                                    ? " "
                                    : _vm.commentsCount
                                ),
                              },
                            }),
                            _vm._v(" " + _vm._s(_vm.__("globals.comments"))),
                          ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "font-small-3 text-bold-700" },
                  [
                    _c("social-share", {
                      attrs: {
                        id: this.data.id,
                        social: this.data.module.socialShare,
                      },
                      on: { shareModal: _vm.triggerShareModal },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.sidebar === false
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "mr-auto ml-1 mb-1" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-danger",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.report.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.__("globals.report")) + " ")]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.commentsShow
      ? _c(
          "div",
          [
            _c("comments", {
              attrs: {
                newsfeed_uuid: this.data.uuid,
                id: this.data.module.zoom_id,
                type: this.data.type,
              },
              on: { length: _vm.updateCommentsCount },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.share_newsfeed
      ? _c(
          "div",
          [
            _c("share-modal", {
              attrs: {
                original_newsfeed_id: this.data.id,
                module: this.data,
                type: "zoom",
              },
              on: {
                closeModal: function ($event) {
                  _vm.share_newsfeed = false
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }